import React, { useEffect } from "react";
import useAxios from "../../utils/useAxios";
import { useState } from "react";
import { showModal } from "../../utils/modalUtility";

const MasterOcassion = ({ activeTab, setActiveTab }) => {
  const [masterOccasions, setMasterOccasion] = useState([]);
  const [isEditMode, setIsEditMode] = useState(false);

  const [loading, setLoading] = useState(false);
  const [masterOccasionFormData, setMasterOccasionFormData] = useState({
    occasion_name: "",
  });
  const axiosAPI = useAxios(); // Use the custom hook for Axios

  async function fetchMasterOccasion() {
    // setLoading(true); // Start loading
    try {
      const res = await axiosAPI.get(`/api/gifts/get-master-occasions`);
      setMasterOccasion(res.data.results);
    } catch (err) {
      console.error("Error fetching occasions:", err);
    } finally {
      setLoading(false); // Always stop loading
    }
  }

  const handleAddOccasion = async () => {
    const occasion_name = masterOccasionFormData?.occasion_name?.trim();

    if (!occasion_name) {
      window.notifyMessage("Error", "Occasion name is required", "error");
      return;
    }

    try {
      const payload = { occasion_name: occasion_name };
      console.log("Payload", payload);

      const response = await axiosAPI.post(
        "/api/gifts/add-master-occasion",
        payload
      );
      const data = response.data || [];

      // Optional: double check status code
      if (![200, 201].includes(response.status)) {
        throw new Error(data.message || "Something went wrong");
      }
      // Show success message
      window.notifyMessage("Success", "Occasion added successfully", "success");

      // Optionally add to frontend list (if you’re maintaining one)
      // const newGift = { id: data.giftId || Date.now(), name: giftName };
      // setGiftList((prev) => [...prev, newGift]);

      // Clear input
      fetchMasterOccasion();
      setMasterOccasionFormData({ occasion_name: "" });
    } catch (error) {
      console.error("Failed to add gift:", error.message);
      window.notifyMessage(
        "Error",
        error.message || "Failed to add gift",
        "error"
      );
    }
  };

  const handleDeleteGift = async (id) => {
    try {
      const isConfirmed = window.confirm(
        "Are you sure you want to delete this occasion?"
      );
      if (!isConfirmed) return;

      const response = await axiosAPI.delete(
        `/api/gifts/delete-master-occasion/${id}`
      );
      const data = response.data;

      // Optional: double check status code
      if (![200, 204].includes(response.status)) {
        throw new Error(data.message || "Something went wrong");
      }

      window.notifyMessage(
        "Success",
        "Occasion deleted successfully",
        "success"
      );

      setMasterOccasion((prevList) =>
        prevList.filter((gift) => gift.id !== id)
      );

      //  Refresh the list after deletion
      // fetchMasterGift();
    } catch (error) {
      console.error("Failed to delete gift:", error.message);
      window.notifyMessage(
        "Error",
        error.message || "Failed to delete gift",
        "error"
      );
    }
  };

  function handleMasterOccasion(e) {
    const { name, value } = e.target;
    console.log(name, value);
    setMasterOccasionFormData((prev) => ({ ...prev, [name]: value }));
  }

  function openOccasionModal() {
    showModal("openMasterOccasionModal");
  }

  useEffect(() => {
    fetchMasterOccasion(); // Call the function when the component mounts
  },[]);

  return (
    <div>
      <div>
        <div className="d-flex flex-column flex-md-row justify-content-end align-items-stretch align-items-md-center mb-3 gap-2">
          {/* <div>
            <ul className="nav nav-tabs">
              <li className="nav-item">
                <button
                  className={`nav-link ${
                    activeTab === "gifts" ? "active" : ""
                  }`}
                  onClick={() => setActiveTab("gifts")}
                >
                  Gifts
                </button>
              </li>
              <li className="nav-item">
                <button
                  className={`nav-link ${
                    activeTab === "occasion" ? "active" : ""
                  }`}
                  onClick={() => setActiveTab("occasion")}
                >
                  Occasions
                </button>
              </li>
            </ul>
          </div> */}
          <div>
            <button
              type="button"
              className="btn btn-success btn-round"
              onClick={openOccasionModal}
            >
              Add Occasion
            </button>
          </div>
        </div>
        <div
          className="modal fade"
          id="openMasterOccasionModal"
          tabIndex="-1"
          aria-labelledby="openMasterOccasionModal"
          aria-hidden="true"
        >
          <div
            className={
              "modal-dialog modal-dialog-scrollable modal-dialog-centered modal-md"
            }
          >
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="openMasterOccasionModal">
                  {isEditMode ? "Edit Master Occasion" : "Add Master Occasion"}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={() => {
                    // closeModal();
                  }}
                ></button>
              </div>

              <div className="modal-body">
                {/* === Add Gift Manually === */}
                <div className="mb-4">
                  <label htmlFor="occasion_name" className="form-label">
                    Occasion Name
                  </label>
                  <div className="d-flex gap-2">
                    <input
                      type="text"
                      id="occasion_name"
                      name="occasion_name"
                      className="form-control"
                      value={masterOccasionFormData?.occasion_name}
                      placeholder="Enter Occasion name"
                      onChange={handleMasterOccasion}
                    />
                    <button
                      className="btn btn-success btn-sm"
                      onClick={handleAddOccasion}
                    >
                      Add
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Gift table */}

        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div className="card-header d-flex justify-content-between align-items-center flex-wrap gap-3">
                <h4 className="card-title mb-0">
                  All Occasions ({masterOccasions?.length})
                </h4>
              </div>
              <div className="card-body">
                <div className="table-responsive">
                  <table className="table table-striped">
                    <thead>
                      <tr>
                        <th>SR NO</th>
                        <th>Name</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {loading ? (
                        <tr>
                          <td colSpan="3" className="text-center">
                            {/* Loading... */}
                            <div
                              style={{
                                position: "fixed",
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0,
                                zIndex: 9999,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <div
                                className="spinner-border text-success"
                                role="status"
                                style={{ width: "3rem", height: "3rem" }}
                              >
                                <span className="visually-hidden">
                                  Loading...
                                </span>
                              </div>
                            </div>
                          </td>
                        </tr>
                      ) : masterOccasions.length === 0 ? (
                        <tr>
                          <td colSpan="3" className="text-center">
                            No Data Found
                          </td>
                        </tr>
                      ) : (
                        masterOccasions.map((occasions,index) => {
                          return (
                            <tr key={occasions.id}>
                              <td>{index + 1}</td>
                              <td>{occasions?.occasion_name}</td>

                              <td>
                                <button
                                  className="btn btn-dark btn-round btn-icon btn-sm me-2"
                                  onClick={() => handleDeleteGift(occasions.id)}
                                >
                                  <i className="fas fa-trash"></i>
                                </button>
                              </td>
                            </tr>
                          );
                        })
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MasterOcassion;
